export type MemoryStatus = 'saved' | 'blocked' | 'override' | null;

export function governedMemoryStatusFromResponse(
  data: { blocked?: unknown; memory_blocked?: unknown; override_mode?: unknown; memory_saved?: unknown } | null | undefined,
  memoryOverride = false,
): MemoryStatus {
  if (data?.blocked === true || data?.memory_blocked === true) return 'blocked';
  if (data?.override_mode === true || memoryOverride) return 'override';
  return data?.memory_saved === true ? 'saved' : null;
}
